import { useTranslation } from "react-i18next";
import { useDisableCRUD } from "../../../../../../store/admin/companiesStore";
import { CRUDTooltip } from "../../../../../../components/base/CRUDTooltip";
import type { ThemeClasses } from "../types";
import { GroupFilters } from "./GroupFilters";
import { GroupViewToggle } from "./GroupViewToggle";
import useIsMonitor from "../../../../../../hooks/useIsMonitor";
interface GroupHeaderProps {
  themeClasses: ThemeClasses;
  isDarkMode: boolean;
  status_id: string;
  searchQuery: string;
  selectedView: "grid" | "list";
  onStatusChange: (value: string | null) => void;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onViewChange: (view: "grid" | "list") => void;
  onAddNew: () => void;
}

export function GroupHeader({
  themeClasses,
  isDarkMode,
  status_id,
  searchQuery,
  selectedView,
  onStatusChange,
  onSearchChange,
  onViewChange,
  onAddNew,
}: GroupHeaderProps) {
  const { t } = useTranslation("adminSections");
  const disableCRUD = useDisableCRUD();
  const { isMonitor, isReadOnly } = useIsMonitor();
  return (
    <div
      className={`${themeClasses.bg} border-b ${themeClasses.border} px-4 py-3 sm:px-6 sm:py-4`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 mb-3">
        <div className="min-w-0">
          <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
            {t("groups.title")}
          </h1>
          <p className={`text-sm ${themeClasses.textSecondary} mt-1`}>
            {t("groups.subtitle")}
          </p>
        </div>
        {!isMonitor && !isReadOnly && (
          <CRUDTooltip className="self-start sm:self-auto flex-shrink-0">
            <button
              onClick={onAddNew}
              disabled={disableCRUD}
              className="bg-primary-500 hover:bg-primary-400 text-gray-900 px-3 sm:px-4 py-2 rounded-lg font-medium flex items-center justify-center space-x-2 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
            >
              <i className="ri-add-line"></i>
              <span className="hidden sm:inline">{t("groups.addGroup")}</span>
              <span className="sm:hidden">Nuevo</span>
            </button>
          </CRUDTooltip>
        )}
      </div>

      <div className="flex items-center gap-2 min-w-0">
        <GroupFilters
          status_id={status_id}
          searchQuery={searchQuery}
          isDarkMode={isDarkMode}
          themeClasses={themeClasses}
          onStatusChange={onStatusChange}
          onSearchChange={onSearchChange}
        />

        <GroupViewToggle
          selectedView={selectedView}
          themeClasses={themeClasses}
          onViewChange={onViewChange}
        />
      </div>
    </div>
  );
}
